import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../redux/store';

export default () => useDispatch<AppDispatch>();

/**
 * Reason for this hook:
 * For useDispatch, the default Dispatch type does not know about thunks.
 * In order to correctly dispatch thunks, you need to use the specific customized
 * AppDispatch type from the store that includes the thunk middleware types,
 * and use that with useDispatch. Adding a pre-typed useDispatch hook keeps you
 * from forgetting to import AppDispatch where it's needed.
 */
